import { APICore } from '../../helpers/api/apiCore';
import * as URL from "../../helpers/api/apiEndPoint"

const api = new APICore();


function commodity(params: any): any {
    const { search, limit, pages, status } = params.data
    return api.get(`${URL.COMMODITY_GET}search=${encodeURIComponent(search)}&limit=${limit}&page=${pages}&status=${status}`);
}

function createCommodity(params: any): any {
    const { data } = params
    return api.create(URL.COMMODITY_POST, data);
}
function updateCommodity(params: any): any {
    const { data } = params
    return api.update(URL.COMMODITY_UPDATE, data);
}
function deleteCommodity(params: any): any {
    const { data } = params;
    return api.delete(`${URL.COMMODITY_DELETE}_id=${data?.id}`);
}
function uploadCommodity(params: any): any {
    const { data } = params;
    return api.create(URL.COMMODITY_UPLOAD, data);
}

export { commodity, createCommodity, updateCommodity, deleteCommodity, uploadCommodity } 